import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=6a7f9255&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&id=6a7f9255&prod&lang=scss&scoped=true&"
import style1 from "./phone.vue?vue&type=style&index=1&id=6a7f9255&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7f9255",
  null
  
)

export default component.exports